/** @format */

import COLORS from '../../colors';
import OPL_STYLE from '../../OplStyle';

const OplTableStyle = {
    tableCellRoot: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        backgroundClip: 'padding-box',
        position: 'relative',
    },
    tableCellRootBordered: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        backgroundClip: 'padding-box',
        position: 'relative',
    },
    tableCellRootBorderedClientName: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'break-word',
        width: '200px',
        minWidth: '200px',
        maxWidth: '200px',
        backgroundClip: 'padding-box',
        position: 'relative',
    },
    tableRowRoot: {
        '&:hover td': {
            backgroundColor: `${COLORS.DARK_FUNCTION.FUNCTION_6} !important`,
        },
    },
    paperMargin: {
        marginTop: '30px',
    },
    paperContent: {
        backgroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
        width: 'fit-content',
        marginRight: '15px',
        borderRadius: '6px',
    },
    tableRoot: {
        backgroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
        minWidth: '83vw',
    },
    tableRootNotMinWidth: {
        backgroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
    },
    tableStickyHeader: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        position: 'sticky',
        top: '0',
        zIndex: '1',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderCollapse: 'separate',
        backgroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
        '&:last-child': {
            padding: '5px 0',
        },
        backgroundClip: 'padding-box',
    },
    tableStickyCommand: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        position: 'sticky',
        top: '0',
        left: '0',
        zIndex: '1',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderCollapse: 'separate',
        backgroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
        backgroundClip: 'padding-box',
    },
    tableControlStickyHeader: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        left: '0',
        zIndex: '2',
        position: 'sticky',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        backgroundClip: 'padding-box',
        backgroundColor: OPL_STYLE.BACKGROUND.SECONDARY,
    },
    tableStickyHeaderBordered: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        top: '0',
        zIndex: '1',
        position: 'sticky',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        borderCollapse: 'separate',
        backgroundClip: 'padding-box',
    },
    tableControlSticky: {
        display: 'table-cell',
        padding: '5px 0',
        paddingLeft: '15px',
        fontSize: '11px',
        fontWeight: '400',
        lineHeight: '20px',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        letterSpacing: '0.01071em',
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        left: '0',
        zIndex: '0',
        position: 'sticky',
        backgroundColor: 'white',
        backgroundClip: 'padding-box',
    },
    tableCellRootHovered: {
        '&:hover': {
            backgroundColor: `${COLORS.DARK_FUNCTION.FUNCTION_6} !important`,
        },
    },
    topLabelPadding: {
        padding: '15px 0',
    },
    beforeTableContent: {},
};
export default OplTableStyle;
